import { _query } from '../utils/query.js'

// import { btnLoadingStart, btnLoadingDone } from './loading'

function checkForCloseMatch (longString, shortString) {
  // too many false positives with very short strings
  if (shortString.length < 3) return ''
  // test if the shortString is in the string (so everything is fine)
  if (longString.includes(shortString)) return ''

  const [domainPart, domainRightPart] = longString.split('.')
  if (domainPart.length > 3) {
    if (shortString.includes(domainPart)) {
      return `${shortString}.${domainRightPart}`
    }
  }

  // split the shortString string into two at each postion e.g. g|mail gm|ail gma|il gmai|l
  // and test that each half exists with one gap
  for (let i = 1; i < shortString.length; i++) {
    const firstPart = shortString.substring(0, i)
    const secondPart = shortString.substring(i)

    // test for wrong letter
    const wrongLetterRegEx = new RegExp(`${firstPart}.${secondPart.substring(1)}`)
    if (wrongLetterRegEx.test(longString)) {
      return longString.replace(wrongLetterRegEx, shortString)
    }

    // test for extra letter
    const extraLetterRegEx = new RegExp(`${firstPart}.${secondPart}`)
    if (extraLetterRegEx.test(longString)) {
      return longString.replace(extraLetterRegEx, shortString)
    }

    // test for missing letter
    if (secondPart !== 'mail') {
      const missingLetterRegEx = new RegExp(`${firstPart}{0}${secondPart}`)
      if (missingLetterRegEx.test(longString)) {
        return longString.replace(missingLetterRegEx, shortString)
      }
    }

    // test for switched letters
    const switchedLetters = [
      shortString.substring(0, i - 1),
      shortString.charAt(i),
      shortString.charAt(i - 1),
      shortString.substring(i + 1)
    ].join('')

    if (longString.includes(switchedLetters)) {
      return longString.replace(switchedLetters, shortString)
    }
  }

  // if nothing was close, then there wasn't a typo
  return ''
}

function checkForDomainTypo (userEmail) {
  const domains = ['gmail', 'hotmail', 'outlook', 'yahoo', 'icloud', 'mail', 'zoho']
  const [leftPart, rightPart] = userEmail.split('@')
  if (!rightPart) {
    return '';
  }

  for (let i = 0; i < domains.length; i++) {
    const domain = domains[i]

    const result = checkForCloseMatch(rightPart, domain)

    if (result) return `${leftPart}@${result}`
  }

  return ''
}

function checkForNameTypo (userEmail, name) {
  const [leftPart, rightPart] = userEmail.split('@')
  const result = checkForCloseMatch(leftPart, name)

  if (result) return `${result}@${rightPart}`

  return ''
}

function checkForCommonTypos (userInput) {
  const commonTypos = [
    {
      pattern: /,com$/,
      fix: str => str.replace(/,com$/, '.com')
    },
    {
      pattern: /,co\.\w{2}$/,
      fix: str => str.replace(/,(co\.\w{2}$)/, '.$1')
    },
    {
      pattern: /@\w*$/,
      fix: str => str + '.com'
    }
  ]

  const typo = commonTypos.find(typo => typo.pattern.test(userInput))

  if (typo) return typo.fix(userInput)

  return ''
}

export function checkForTypo (userInput) {
  const email = userInput.email.trim().toLowerCase()

  return checkForCommonTypos(email) ||
    checkForDomainTypo(email)
  // || checkForNameTypo(email, userInput.firstName.trim().toLowerCase())
  // || checkForNameTypo(email, userInput.lastName.trim().toLowerCase())
}

// const firstNameEl = _query('[name="firstName"]')
// const lastNameEl = _query('[name="lastName"]')

// const checkButtonEl = _query('#check')

export async function gatherDataAndCheck () {
  const emailEl = _query('[name="email-capture"]')
  if (emailEl && emailEl.value !== '') {
    window.suggestedEmail = checkForTypo({
      // firstName: firstNameEl.value,
      // lastName: lastNameEl.value,
      email: emailEl.value
    })

    if (window.suggestedEmail !== '') {
      return window.suggestedEmail
    }

      return ''

  }

    return ''


}

export async function suggestedMessage () {

  const messageEl = _query('#SuggestMessage')
  const suggestedEmail = await gatherDataAndCheck()

  if (suggestedEmail !== '') {
    if (messageEl !== null) {
      messageEl.classList.add('shown')
      messageEl.innerHTML = `Did you mean <span class=ClickableEmail>${suggestedEmail}</span>?`
      messageEl.focus()
    }
  } else {
    if (messageEl !== null) {
      messageEl.textContent = ''
    }

    return ''
  }

}

export async function fixedEmail (extra) {
  try {
    const messageEl = _query('#SuggestMessage')
    const emailEl = _query('[name="email-capture"]')
    await new Promise((resolve, reject) => {
      if (window.suggestedEmail) {
        emailEl.value = window.suggestedEmail
        // emailEl.focus()
        if (extra) {
          _query(extra).value = window.suggestedEmail
        }

        // console.info(`fixedEmail: suggestedEmail= ${window.suggestedEmail}`)
        messageEl.classList.remove('shown')
        // gatherDataAndCheck()
        reject(window.suggestedEmail)
      } else {
        // barba.go('/store/order/review-cart')
        resolve()
      }
    })
  } catch (e) {
    console.info(`fixedEmail: reject= ${e}`)
  }
}

// checkButtonEl.addEventListener('click', gatherDataAndCheck)

// messageEl.addEventListener('click', fixedEmail)

window.gatherDataAndCheck = gatherDataAndCheck
window.fixedEmail = fixedEmail
window.checkForTypo = checkForTypo
window.suggestedMessage = suggestedMessage
